import React, { useState } from "react";
import {Modal} from 'react-bootstrap';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faInfo} from "@fortawesome/free-solid-svg-icons";
import "react-datepicker/dist/react-datepicker.css";
import RequestDescription from "./RequestDescription";
import RespondForm from './RespondForm';
import {sendModalRespond} from '../../../../../functions/api';

function RespondModal(props) {
        const {show, setShow, problem_content, date, id, category, update, setActiveId} = props
        const [message, setMessage] = useState('');
        const [startDate, setStartDate] = useState(new Date());
        const [currentDate, setCurrentDate] = useState(startDate);
        const [displayedMonth, setDisplayedMonth] = useState(new Date().getMonth())
        const [problemId, setProblemId] = useState(null);
        const [data, setData] = useState({});
        const [ifSent, setIfSent] = useState(false);
        const [errors, setErrors] = useState([]);
        let {earliest_available_date} = data

        const submitResponse = async (e) => {
            e.preventDefault();
            sendMessage();
            setErrors([]);
            setData({...data, created: new Date().toLocaleString()})
            
        }

        const sendMessage = async () => {
            sendModalRespond(problemId, earliest_available_date, message, setErrors, setIfSent, data)
        }
        const handleData = (event) => {
            setData(event)
        }

        const handleDataChange = (event) => {
            let name = event.target.name
            let value = event.target.value
            setData({...data, [name]: value})
        }

        const handleChecked = (value) => {
            setData({...data, or_per_case: !value})
        }

        const handleChange = (event) => {
            setMessage(event.target.value);
        }

        const handleStartDate = (event) => {
            setStartDate(event)
            setStartDate(event);
            setCurrentDate(null)
        }

        const handleEarliestDate = (event) => {
            setData({...data, earliest_available_date: event})
        }

        const handleCurrentDate = (event) => {
            setCurrentDate(event)
            setData({...data, earliest_available_date: event})
        }

        const handleMonthChange = (event) => {
           setCurrentDate(null)
           setStartDate(null)
            setDisplayedMonth(event.getMonth())
        }

        const handleProblemId = (event) => {
            setProblemId(event)
        }

        return(
            <>
            <Modal show={show}  onHide={() => {setShow(false); setActiveId('')}}>
                <Modal.Header closeButton onClick={update}>
                    <Modal.Title>
                        <FontAwesomeIcon icon={faInfo} className='fa-info'/>
                        Twoja odpowiedź
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <YellowInfo ifSent={ifSent}/>
                    <form className='row' onSubmit={submitResponse}>
                        <RequestDescription problem_content={problem_content}
                        id={id}
                        date={date}
                        category={category}
                        message={message}
                        handleChange={handleChange}
                        ifSent={ifSent}
                        />
                        <RespondForm
                        id={id}
                        data={data}
                        handleDataChange={handleDataChange}
                        startDate={startDate}
                        handleStartDate={handleStartDate}
                        handleEarliestDate={handleEarliestDate}
                        handleCurrentDate={handleCurrentDate}
                        currentDate={currentDate}
                        handleMonthChange={handleMonthChange}
                        earliestDate={earliest_available_date}
                        displayedMonth={displayedMonth}
                        handleProblemId={handleProblemId}
                        handleData={handleData}
                        ifSent={ifSent}
                        handleChecked={handleChecked}
                        message={message}
                        errors={errors}
                        setErrors={setErrors}
                        />
                        {ifSent ? <></> : <div className="submit-form top-buffer">
                            <input type="submit" value="Wyślij" className="submit-btn"/>
                        </div>}
                    </form>
                </Modal.Body>
            </Modal>
            </>
        )
}

class YellowInfo extends React.Component {
    render() {
        const {ifSent} = this.props
        if (ifSent) 
        return (
            <div className="yellow_info">
                <span>Twoja odpowiedź została wysłana, klient może teraz skontaktować się bezpośrednio z Tobą.</span> <br/>
                <span>Sprawa została przeniesiona do zakładki 'moje sprawy'.</span>
            </div>
        )
    }
}

export default RespondModal